import { TabsReducer } from '../../../common/tabs/tabs.reducer';

export const settingsTabs = {
    'app.policies.settings.categories.add': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.settings.categories.add.details',
                title: 'Document Category Details',
                visible: true,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    },
    'app.policies.settings.categories.manage': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.settings.categories.manage.listing',
                title: 'Document Categories',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.settings.categories.manage.details',
                title: 'Document Category Details',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    },
    'app.policies.settings.approval_workflows.add': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.settings.approval_workflows.add.details',
                title: 'Approval Workflow Details',
                visible: true,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    },
    'app.policies.settings.approval_workflows.manage': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.settings.approval_workflows.manage.listing',
                title: 'Approval Workflows',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: 'app.policies.settings.approval_workflows.manage.details',
                title: 'Approval Workflow Details',
                visible: false,
                disabled: false,
                loading: false,
                buttons: {
                    execute: {label: 'Save'}
                }
            }
        ]
    },
    'app.policies.settings.compliance_report': {
        ...TabsReducer(),
        tabs: [
            {
                state: 'app.policies.settings.compliance_report',
                title: 'Compliance Report',
                visible: true,
                disabled: false,
                loading: false,
            }
        ]
    }
};
